import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class ProxyService {

  constructor( private httpService: HttpService) { }

  saveProxyRecord(object) {
      var response = {
          URL: "proxy/proEntry",
          DATA: object
      }
      return this.httpService.post(response);
  }

  getAllProxyDetails(object) {
      var registerList = {
          URL: "proxy/getProxy/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(registerList);

  }

  getproxyById(_id) {
      var editlist = {
          URL: "proxy/getProxyWithId/" + _id,
      }
      return this.httpService.get(editlist);
  }

  updateProxy(object, id) {
      var request = {
          URL: "proxy/updateProxy/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  removeproxydetails(_id) {
      var request = {
          URL: "proxy/deletadetails/" + _id
      }
      return this.httpService.get(request);
  }
  generateProxyDocument(object) {
      var request = {
          URL: "proxy/generateProxyDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadProxyFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "proxy/downloadDocument/" + id + "/" + type + "/" + token;
  }
  downloadProxyPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "proxy/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
}
